var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { isArray, isEmpty, map, result, find } from 'lodash';
/**
 * 根据value和options返回value中id数组对应的对象数组
 * @param {Array} options
 * @param {Array} value
 */

function findTreeNodeArray(options, value) {
  var result = [];

  if (isEmpty(value)) {
    return result;
  }

  var cursor = 0;
  var treeMap = {}; //先判断是否已经有完整的结果，然后判断在treeMap中已有对应的节点信息，如果有推入result中，游标前进，重复校验

  var validate = function validate() {
    //发现遍历完毕立刻退出
    if (cursor >= value.length) {
      return true;
    }

    var temp = treeMap[value[cursor]];

    if (temp) {
      result[cursor] = temp;
      cursor++;
      return validate();
    }

    return false;
  };

  (function treeLoop(treeData) {
    if (validate()) {
      return true;
    }

    for (var _i = 0, treeData_1 = treeData; _i < treeData_1.length; _i++) {
      var item = treeData_1[_i];

      var node = __assign(__assign({}, item), {
        id: item.id,
        children: null,
        name: item.name
      }); //继续判断是否找到对应的treeNode，如果有推入result中，游标前进，触发校验，否则记录treeNode信息


      if (item.id === value[cursor]) {
        result[cursor] = node;
        cursor++;

        if (validate()) {
          return true;
        }
      } else {
        treeMap[item.id] = node;
      }

      if (isArray(item.children) && treeLoop(item.children)) {
        return true;
      }
    }
  })(options);

  return result;
}
/**
 * 将id数组转换为id,name对象数组
 * @param {Array} value
 * @param {Array} options
 * @return {Array}
 */


function convertTreeNodeIdArrayToTreeNodeArray(value, options) {
  return findTreeNodeArray(options, value);
}
/**
 * 将id转换为id,name对象
 * @return {Object}
 * @param {String} value
 * @param {Array} options
 */


function convertTreeNodeIdToTreeNode(value, options) {
  // if (isEmpty(value)) {
  //     return undefined;
  // }
  return findTreeNodeArray(options, [value])[0];
}
/**
 * 将value转换为需要的objectArray形式
 * @param {String} value
 * @param {Array} options
 * @return {Array}
 */


var convertTreeNodeIdToTreeNodeArray = function convertTreeNodeIdToTreeNodeArray(value, options) {
  var result = [];

  (function loop(options) {
    for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
      var option = options_1[_i];
      var item = {
        id: option.id,
        name: option.name
      };

      if (option.id === value) {
        result.push(item);
        return true;
      }

      if (isArray(option.children)) {
        result.push(item);

        if (loop(option.children)) {
          return true;
        }
      }
    } //如果循环到最后都没找到，退出之前推入的item


    result.pop();
  })(options);

  return result;
};

var convertOptionsIdArrayToOptionsArray = function convertOptionsIdArrayToOptionsArray(value, options) {
  var convertResult = [];
  convertResult = map(value, function (item, _index) {
    return {
      id: item,
      name: result(find(options, function (option) {
        return option.id === String(item);
      }), 'name')
    };
  });
  return convertResult;
};

export { convertTreeNodeIdArrayToTreeNodeArray, convertTreeNodeIdToTreeNode, convertTreeNodeIdToTreeNodeArray, convertOptionsIdArrayToOptionsArray };